var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallRibbon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smallribbon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "leftside"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.42,321.88c-54.1-34.81-116.11-54.68-178.82-40.31-8.23,1.89-20.84,11.98-19.22,20.27,3.1,9.62,15.57,6.57,22.98,2.33.62-.35,1.29.41.86.97-5.72,7.52-21.74,11.41-18.95,26.46.63,9.4,10.16,15.45,18.98,18.75,13.22,4.95,37.28,6.16,51.4,5.86",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.48,339.64c-52.93-15.55-128.19-22.07-181.67-.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.61,330.97c-43.38,5.48-88.76,28.53-120.15,45.8-6,3.3-21.72,17-21.45,29.58-.28,10.56,15.41,11.52,18.04,10.44",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.42,350.52c-49.53,11.22-97.6,42-139.07,71.31-14.68,10.38-22.27,25.57-8.39,26.1,7.56.29,12.65-1.84,19.22-5.59,50.85-29.01,89.6-50.28,128.24-84.86",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.2,396.11c-6.57,5.42-15.51,34.35,1.44,41.34",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.06,360.79c-14.69,47.75-17.38,101.15-28.95,149.75-1.68,7.04-3.55,14.05-4.47,21.22-.93,7.28-.87,14.65-.81,21.99.14,15.84.27,31.68.41,47.52.17,19.49.34,39.01,2.29,58.4,1.66,16.51,4.62,32.93,4.77,49.53.37,39.57-16.11,78.97-44.31,106.69-2.64,2.59-2.27,6.89.68,9.12,15.08,11.35,23.22,29.42,27.57,46.14.62,2.39,3.9,2.66,4.92.41,13.82-30.41,25.99-45.56,36.98-76.89,9.44-26.91,7.08-96.22,4.68-117.97-2.25-20.46-4.66-40.95-9.3-61-8.54-36.89-24.5-71.63-35.05-108-10.56-36.37-8.58-91.54,5.05-126.87",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "rightside"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.27,321.88c54.1-34.81,116.11-54.68,178.82-40.31,8.23,1.89,20.84,11.98,19.22,20.27-3.1,9.62-15.57,6.57-22.98,2.33-.62-.35-1.29.41-.86.97,5.72,7.52,21.74,11.41,18.95,26.46-.63,9.4-10.16,15.45-18.98,18.75-13.22,4.95-37.28,6.16-51.4,5.86",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.26,338.83c52.93-15.55,125.14-21.27,178.62,0",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.09,330.96c43.38,5.48,88.76,28.53,120.15,45.8,6,3.3,21.72,17,21.45,29.58.28,10.56-15.41,11.52-18.04,10.44",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,350.52c49.53,11.22,97.6,42,139.07,71.31,14.68,10.38,22.27,25.57,8.39,26.1-7.56.29-12.65-1.84-19.22-5.59-50.85-29.01-89.6-50.28-128.24-84.86",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.5,396.11c6.57,5.42,15.51,34.35-1.44,41.34",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.1,360.37c14.69,47.75,16.92,101.56,28.49,150.16,1.68,7.04,3.55,14.05,4.47,21.22.93,7.28.87,14.65.81,21.99-.14,15.84-.27,31.68-.41,47.52-.17,19.49-.34,39.01-2.29,58.4-1.66,16.51-4.62,32.93-4.77,49.53-.37,39.57,16.11,78.97,44.31,106.69,2.64,2.59,2.27,6.89-.68,9.12-15.08,11.35-23.22,29.42-27.57,46.14-.62,2.39-3.9,2.66-4.92.41-13.82-30.41-25.99-45.56-36.98-76.89-9.44-26.91-7.08-96.22-4.68-117.97,2.25-20.46,4.66-40.95,9.3-61,8.54-36.89,24.5-71.63,35.05-108,10.56-36.37,8.67-94.13-4.96-129.47",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M312,314.1c2.4.36,4.56,1.6,6.35,3.25,1.99,1.84,13.33,8.83,14.34,21.56.36,4.52-4.05,13.89-10.04,18.02-6.81,4.7-10.31,5.81-16.67,6.31-8.47.68-13.99,0-23.92-4.83-12.06-6.41-10.78-22.82-9.81-27.22s3.85-8.68,8.1-10.29c1.93-.73,4.04-.9,6.1-.85,2.23.05,4.49.37,6.6,1.1.2.07.4.15.6.24,2.69,1.22,5.86.36,7.34-2.2,1.98-3.44,5.02-5.98,11-5.08Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "smallribbonwhite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.09,311.9c6.14-1.08,69.01-30.35,112.36-24.21",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.27,344.05c11.2,0,70.09,6.5,109.11,32.16",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 474.45,
    y1: 384.52,
    x2: 480.95,
    y2: 389.58,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.72,331.05c-1.17-2.29,1.85-5.25,4.3-6.06,1.63-.54,3.49-.07,4.88.93s2.38,2.49,3.09,4.06",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.77,387.45c.71,4.78,2.02,9.44,3.12,14.14,5.24,22.26,5.93,45.31,6.59,68.17",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,396.51c-4.37,27.7-6.75,55.71-7.14,83.75",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.94,393.44c1.91-2.73,27.29-17.46,33.83-20.74",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.84,293.84c3-.55,25.92-9.28,39.29-5.46",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallRibbon);
export default __webpack_public_path__ + "static/media/smallRibbon.b5d725c7073d8177079036ced6e1d1df.svg";
export { ForwardRef as ReactComponent };